import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mx-6 d-flex" }
const _hoisted_2 = {
  class: "text-subtitle-2 mt-2",
  style: {"width":"80px"}
}
const _hoisted_3 = { class: "d-flex justify-end my-6 mr-4" }

import {ref, onMounted} from 'vue'
import {game} from "@/api";
import {useApi} from "@/api/handler";
import {ApiMap} from "@/api/type";


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamTile',
  props: {
    gameId: {}
  },
  emits: ["update", "close"],
  setup(__props: any, { emit: __emit }) {

const gradeRank = ref<ApiMap['/game/xxt/rank/:id']['resp']>([])

const props = __props

const emits = __emit

const form = ref<Record<number, number>>({})

onMounted(() => {
  useGradeRank()
})

const useUploadAssign = () => {
  useApi({
    api: game.UploadAssign(props.gameId, form.value),
    onSuccess: () => { emits('update'); emits('close') },
    tip: '设置成功'
  })
}

const useGradeRank = () => {
  useApi({
    api: game.GradeRank(props.gameId),
    onSuccess: resp => {
      gradeRank.value = resp.data as ApiMap['/game/xxt/rank/:id']['resp']
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-4",
    "min-width": "400"
  }, {
    default: _withCtx(() => [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-lg-h6 mb-4" }, "分配每组可选格子数", -1)),
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(useUploadAssign, ["prevent"])
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gradeRank.value.map((item) => item.teamId), (id) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-2",
              key: id
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, " 第 " + _toDisplayString(id) + " 组： ", 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value[id],
                    "onUpdate:modelValue": ($event: any) => ((form.value[id]) = $event),
                    modelModifiers: { number: true },
                    type: "number",
                    min: "1",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_btn, {
              type: "submit",
              color: "primary"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("提交")
              ])),
              _: 1,
              __: [1]
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
              color: "red-lighten-2",
              class: "ml-2"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("取消")
              ])),
              _: 1,
              __: [2]
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1,
    __: [3]
  }))
}
}

})